export default __webpack_public_path__ + "static/media/home_how_niyama.c91a8f97.png";